import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import { AnalyticsBootstrap } from "@/components/analytics/AnalyticsBootstrap";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ReviewsPage from "@/pages/ReviewsPage";
import ContactsPage from "@/pages/ContactsPage";
import ThankYouPage from "@/pages/ThankYouPage";

const legacyRedirects: { from: string; to: string }[] = [
  { from: "/zamena-lobovogo-stekla", to: "/services/glass-replacement" },
  { from: "/zamena-bokovogo-stekla", to: "/services/glass-replacement" },
  { from: "/zamena-zadnego-stekla", to: "/services/glass-replacement" },
  { from: "/tonirovka", to: "/services/window-tinting" },
  { from: "/vyyizd-mastera", to: "/contacts" },
  { from: "/remont-skolov", to: "/services/glass-replacement" },
  { from: "/lobove-sklo", to: "/services/glass-replacement" },
  { from: "/ru", to: "/" },
  { from: "/ky", to: "/" },
];

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-8">Сторінку не знайдено</p>
        <a href="/" className="text-primary hover:underline transition-all">
          Повернутися на головну
        </a>
      </div>
    </div>
  );
}

const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <AnalyticsBootstrap />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/contacts" element={<ContactsPage />} />
      <Route path="/spasibo" element={<ThankYouPage />} />
      {legacyRedirects.map(({ from, to }) => (
        <Route key={from} path={from} element={<Navigate to={to} replace />} />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default App;
